import { render } from "./CustomPagination.vue?vue&type=template&id=5209d8b8&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=js"
export * from "./CustomPagination.vue?vue&type=script&lang=js"

import "./CustomPagination.vue?vue&type=style&index=0&id=5209d8b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5209d8b8"]])

export default __exports__